<span #overlayContainer>
    <span #overlayButtonContainer [id]="overlayId">
        <p-button
            [id]="overlayId + '-button'"
            [icon]="'fa-regular fa-circle-' + iconType"
            styleClass="p-button-link"
            class="overlay-icon"
            [class.large-icon]="iconSize === 'large'"
            [class.medium-icon]="iconSize === 'medium'"
            [link]="true"
            [ariaLabel]="overlayAreaLabel | translate"
            (onClick)="infoOverlay.toggle($event); infoOverlay.focus()"
            (keydown.escape)="infoOverlay.hide()">
        </p-button>
    </span>

    <p-overlayPanel #infoOverlay [focusOnShow]="true" [appendTo]="overlayContainer">
        <div
            pFocusTrap
            (keydown.escape)="infoOverlay.hide()"
            [id]="overlayId + '-overlay-content'"
            class="overlay-content">
            <ng-content></ng-content>
        </div>
    </p-overlayPanel>
</span>
